import { useEffect } from "react";
import { pageTitle } from "@/lib/seoPages";

export default function Seo({ title, description, path = "/", noindex = false, jsonLd = null }) {
  useEffect(() => {
    document.title = pageTitle(title);

    const setMeta = (selector, value) => {
      const el = document.head.querySelector(selector);
      if (el) el.setAttribute("content", value);
    };

    if (description) {
      setMeta('meta[name="description"]', description);
      setMeta('meta[property="og:description"]', description);
      setMeta('meta[name="twitter:description"]', description);
    }
    const fullTitle = document.title;
    setMeta('meta[property="og:title"]', fullTitle);
    setMeta('meta[name="twitter:title"]', fullTitle);
    setMeta('meta[property="og:url"]', window.location.origin + path);
    setMeta('meta[name="robots"]', noindex ? "noindex, nofollow" : "index, follow");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", window.location.origin + path);

    let ldEl = document.head.querySelector('script[data-page-jsonld]');
    if (jsonLd) {
      if (!ldEl) {
        ldEl = document.createElement("script");
        ldEl.type = "application/ld+json";
        ldEl.setAttribute("data-page-jsonld", "true");
        document.head.appendChild(ldEl);
      }
      ldEl.textContent = JSON.stringify(jsonLd);
    } else if (ldEl) {
      ldEl.remove();
    }
    return () => {
      const el = document.head.querySelector('script[data-page-jsonld]');
      if (el) el.remove();
    };
  }, [title, description, path, noindex, jsonLd]);

  return null;
}
